import { render } from "./VrHeadsetIcon.vue?vue&type=template&id=5612e40c"
import script from "./VrHeadsetIcon.vue?vue&type=script&lang=js"
export * from "./VrHeadsetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__